import { NavLink } from "react-router";
import Logo  from '../assets/images/IETBHEC.png'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'

function Header() {
	return (
		<header className="header" id="header">
			<div>
				<div className="header_top">
					<div className="row">
						<div className="col">
							<div class="alert-banner">
								<h3 className="blink">
									Due to the current global situation and safety concerns for our global colleagues,
									<span class="highlight">
										this year's conference will be rescheduled.
									</span>
									Please stay tuned for revised dates and location.
								</h3>
							</div>
							<div className="header_top_content d-flex flex-row align-items-center justify-content-start">
								<div className="px-2">
									
									<div className="logo_container d-flex flex-row align-items-start justify-content-start">
										<div className="logo_content" class='header-logos'>
											<div id="logo_text" className="logo_text logo_text_not_ie main-text-color">
												<NavLink to="/"><img src={Logo} alt='' width="40%" /></NavLink>
											</div>
											{/* <div id="header_text_urgent">
												<h3 className="blink"><font color="red">Due to the current global situation and safety concerns for our global colleagues this year's conference will be rescheduled.</font></h3>
											</div> */}
											<div id='curtin-align-right'>
												<img src={CurtinLogo} alt='' width="50%" />
											</div>
										</div>
									</div>
								</div>
								<div className="hamburger ml-auto mr-2" onClick={openNav}><i className="fa fa-bars" aria-hidden="true"></i></div>
							</div>
						</div>
					</div>
				</div>
				<div className="header_nav" id="header_nav_pin">
					<div className="header_nav_inner">
						<div className="header_nav_container">
							<div className="row">
								<div className="col">
									<div className="header_nav_content d-flex flex-row align-items-center justify-content-center text-center">
										<nav className="main_nav">
											<ul>
												<li><NavLink className="navlink-style" to="/">Home</NavLink></li>
												<li><NavLink className="navlink-style" to="/about">About IETEC</NavLink></li>
												<li><NavLink className="navlink-style" to="/call-for-papers">Call for Papers</NavLink></li>
												<li><NavLink className="navlink-style" to="/masterclasses-workshops">Masterclasses/Workshops</NavLink></li>
												{/* <li><NavLink className="navlink-style" to="/registration">Registration</NavLink></li> */}
												<li><NavLink className="navlink-style" to="/sponsorship-exhibition">Sponsorship and Exhibition</NavLink></li>
												<li><NavLink className="navlink-style" to="/venue-accommodation">Venue and Accommodation</NavLink></li>
												<li><NavLink className="navlink-style" to="/program-outline">Program Outline</NavLink></li>
												{/* <li><NavLink className="navlink-style" to="/committee">Organising Committee</NavLink></li> */}
												<li><NavLink className="navlink-style" to="/contact-us">Contact Us</NavLink></li>
											</ul>
										</nav>
										{/* <div className="header_extra ml-auto">
												<div className="header_search"><i className="fa fa-search" aria-hidden="true"></i></div>
												<div className="button header_button"><a href="#">Buy Tickets Now!</a></div>
											</div> */}
									</div>
								</div>
							</div>
						</div>
						{/* <div className="search_container">
							<div className="container">
								<div className="row">
									<div className="col">
										<div className="search_content d-flex flex-row align-items-center justify-content-end">
											<form action="#" id="search_container_form" className="search_container_form">
												<input type="text" className="search_container_input" placeholder="Search" required="required" />
												<button className="search_container_button"><i className="fa fa-search" aria-hidden="true"></i></button>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</div>
		</header>
	)
}

function openNav() {
	document.getElementById("mySidenav").style.width = "250px";
}

export default Header